import { z } from 'zod';

export const entityIdSchema = z.string().trim().min(1).max(128);
export const isoDateSchema = z.iso.date();
export const isoDateTimeSchema = z.iso.datetime({ offset: true });
export const revisionSchema = z.number().int().nonnegative();
export const moneySchema = z.number().int().nonnegative();
export const signedMoneySchema = z.number().int();

export const auditFieldsSchema = z.object({
  createdAt: isoDateTimeSchema,
  createdBy: entityIdSchema.nullable(),
  updatedAt: isoDateTimeSchema,
  updatedBy: entityIdSchema.nullable(),
  revision: revisionSchema,
});

export const paginationQuerySchema = z.object({
  cursor: z.string().trim().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
  search: z.string().trim().max(200).optional(),
});

export const pageMetaSchema = z.object({
  nextCursor: z.string().nullable(),
  count: z.number().int().nonnegative(),
});

export const apiErrorSchema = z.object({
  code: z.string().min(1),
  message: z.string().min(1),
  details: z.record(z.string(), z.unknown()).default({}),
});

export const successEnvelopeSchema = <T extends z.ZodType>(dataSchema: T) =>
  z.object({
    ok: z.literal(true),
    data: dataSchema,
    meta: z.record(z.string(), z.unknown()),
    error: z.null(),
  });

export const errorEnvelopeSchema = z.object({
  ok: z.literal(false),
  data: z.null(),
  meta: z.record(z.string(), z.unknown()),
  error: apiErrorSchema,
});

export type ApiError = z.infer<typeof apiErrorSchema>;
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;
